import React, { memo } from 'react';

import { TableSortLabel, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const defaultObject = {};

const tooltipClasses = {
  popper: {
    '&[role=tooltip]': {
      zIndex: 1500,
    },
  },
};

const TooltipedSortLabel = ({
  isSort = false,
  align,
  id,
  label,
  order = defaultObject,
  onRequestSort,
  ...props
}) => {
  return (
    <>
      {isSort && (
        <Tooltip
          classes={tooltipClasses}
          enterDelay={300}
          placement={align === 'right' ? 'bottom-end' : 'bottom-start'}
          title="Sort"
        >
          <TableSortLabel
            {...props}
            active={order.id === id}
            data-id={id}
            direction={order.direction}
            onClick={onRequestSort}
          >
            {label}
          </TableSortLabel>
        </Tooltip>
      )}

      {!isSort && label}
    </>
  );
};

TooltipedSortLabel.propTypes = {
  align: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  isSort: PropTypes.bool,
  order: PropTypes.object,
  onRequestSort: PropTypes.func,
};

export default memo(TooltipedSortLabel);
